import React from 'react';
import { Chip, PersonAvatar, saldoAnzeige } from '../../../../components/immobilien/ui';
import { eur, initialen, qm } from '../../../../lib/immobilien/format';
import { EIG_STATUS, statusText, type EigZeile } from '../../../../lib/eigentuemer/liste';
import { avatarTon, monatlichTitel } from './EigentuemerKachel';

const SPALTEN = 'minmax(160px,1.4fr) minmax(150px,1.3fr) 112px 64px 72px 88px 88px 120px';

/** Listenansicht (README §6.1): Name · Objekte · Telefon · Einheiten · Fläche · Monatlich · Saldo · Status. */
export function EigentuemerTabelle({ zeilen, onOeffnen }: { zeilen: readonly EigZeile[]; onOeffnen: (id: string) => void }) {
  const tastatur = (id: string) => (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOeffnen(id); }
  };
  return (
    <section className="immo-glas overflow-x-auto" style={{ borderRadius: 26, padding: 6 }} aria-label="Eigentümer als Liste">
      <div role="table" className="flex flex-col" style={{ minWidth: 952 }}>
        <div role="row" className="grid"
          style={{ gridTemplateColumns: SPALTEN, gap: 10, padding: '12px 14px', fontSize: 11, fontWeight: 800, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--ink3)' }}>
          <span role="columnheader">Name</span><span role="columnheader">Objekte</span><span role="columnheader">Telefon</span>
          <span role="columnheader" style={{ textAlign: 'right' }}>Einheiten</span><span role="columnheader" style={{ textAlign: 'right' }}>Fläche</span>
          <span role="columnheader" style={{ textAlign: 'right' }}>Monatlich</span><span role="columnheader" style={{ textAlign: 'right' }}>Saldo</span>
          <span role="columnheader" style={{ textAlign: 'right' }}>Status</span>
        </div>
        {zeilen.map(z => {
          const st = EIG_STATUS[z.status];
          const saldo = saldoAnzeige(z.saldo);
          return (
            <div key={z.id} role="row" tabIndex={0} aria-label={`${z.name} öffnen`} onClick={() => onOeffnen(z.id)} onKeyDown={tastatur(z.id)}
              className="immo-hover-flaeche grid items-center cursor-pointer"
              style={{ gridTemplateColumns: SPALTEN, gap: 10, padding: '10px 14px', borderRadius: 16, fontSize: 13 }}>
              <span role="cell" className="flex items-center min-w-0" style={{ gap: 10 }}>
                <PersonAvatar text={initialen(z.name)} ton={avatarTon(z)} groesse={32} />
                <span className="flex flex-col min-w-0">
                  <b className="truncate" style={{ fontWeight: 800 }}>{z.name}</b>
                  <span className="truncate" style={{ fontSize: 11, color: 'var(--ink3)' }}>{z.email || '–'}</span>
                </span>
              </span>
              <span role="cell" className="flex flex-col min-w-0">
                <span className="truncate" style={{ fontWeight: 600 }}>{z.rollenText || '–'}</span>
                <span className="truncate" style={{ fontSize: 11, color: 'var(--ink3)' }}>{z.objektText}</span>
              </span>
              <span role="cell" className="immo-zahl truncate" style={{ color: 'var(--ink2)' }}>{z.telefon || '–'}</span>
              <span role="cell" className="immo-zahl" style={{ textAlign: 'right' }}>{z.werte.nEinheiten}</span>
              <span role="cell" className="immo-zahl" style={{ textAlign: 'right', color: 'var(--ink2)' }}>{z.werte.flaeche ? qm(Math.round(z.werte.flaeche)) : '–'}</span>
              <b role="cell" className="immo-zahl" title={monatlichTitel(z)} style={{ textAlign: 'right', fontWeight: 800 }}>{z.werte.nEinheiten ? eur(z.werte.monatlich, { nachkomma: 0 }) : '–'}</b>
              <b role="cell" className="immo-zahl" title={saldo.titel} style={{ textAlign: 'right', fontWeight: 800, color: saldo.farbe }}>{saldo.text}</b>
              <span role="cell" className="flex justify-end"><Chip ton={st.ton} groesse="xs">{statusText(z)}</Chip></span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
